define([
	"dojo/_base/declare",
	"csi/action/PopupController",
	"csi/html",
], function(declare, PopupController, html) {

	return declare(PopupController, {
		preProcess() {
			this.m_urlNode = html.getDataAttribute(this.refNode, html.DATA_CALENDAR_ACTIVITY_URL);
			this.inherited(arguments);
		},

		postProcessSuccess() {
			this.widget.redrawNode(this.refNode);
		}
	});
});